import { VIEW_SMS_HISTORY } from '../../../constant/ViewConstant';
import BreadCrumb from '../../../component/BreadCrumb';
import { useCallback, useRef, useState, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CODE_GROUP_ID } from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import PopupRef from '../../../component/PopupRef';
import SelectionBox from '../../../component/SelectionBox';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import ModalRef from '../../../component/ModalRef';
import qs from 'qs';
import NullCheckUtil from '../../../util/NullCheckUtil';
import PathUtil from '../../../util/PathUtil';
import TelNoInputBox from '../../../component/TelNoInputBox';
import DatePickerBox from '../../../component/DatePickerBox';
import { date2ViewDate, viewDate2SaveDate } from '../../../util/TimeTableUtil';
import { formatDt } from '../../../util/DateTimeUtil';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import { actionSmsHistorySearch } from '../../../module/body/sms/SmsHistoryModule';
import TableBox from '../../../component/TableBox';
import { useLocation } from 'react-router-dom';
import { Tooltip, IconButton } from '@material-ui/core';
import { OpenDetailIcon } from '../../../component/icon/GridIcons';
import FormatUtil from '../../../util/FormatUtil';
import { actionSmsSend } from '../../../module/body/sms/SmsSendModule';
import SendIcon from '@material-ui/icons/SendOutlined';
import { OpenEditIcon } from '../../../component/icon/GridIcons';
import SmsHistoryModal from '../../modal/SmsHistoryModal';

const SmsHistoryArea = ({ modalRef, popupRef }) => {
    const location = useLocation();
    const now = new Date();
    const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const { gridData } = useSelector((state) => state.tableBoxState);
    const dispatch = useDispatch();

    const [bgnDt, setBgnDt] = useState(formatDt(firstDay));
    const [endDt, setEndDt] = useState(formatDt(lastDay));
    const [sendTypeCd, setSendTypeCd] = useState('');
    const [resCode, setResCode] = useState('');
    const [phone, setPhone] = useState('');
    const [callback, setCallback] = useState('');

    const [params, setParams] = useState({});

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onChangePageInfo,
                onRowDoubleClick,
                params,
            }),
        );

        queryData.bgnDt && setBgnDt(queryData.bgnDt);
        queryData.endDt && setEndDt(queryData.endDt);
        queryData.sendTypeCd && setSendTypeCd(queryData.sendTypeCd);
        queryData.resCode && setResCode(queryData.resCode);
        queryData.phone && setPhone(queryData.phone);
        queryData.callback && setCallback(queryData.callback);

        onClickSearch({
            bgnDt: queryData.bgnDt || bgnDt,
            endDt: queryData.endDt || endDt,
            userId: queryData.userId,
            sendTypeCd: queryData.sendTypeCd,
            resCode: queryData.resCode,
            phone: queryData.phone,
            callback: queryData.callback,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        return () => {
            dispatch(initGrid());
        };
    }, []);

    const onChangePageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onClickSearch = (params) => {
        setParams(params);
        dispatch(
            actionSmsHistorySearch({
                params,
                callback: (result) => {
                    if (result.totalCount == 0) {
                        popupRef.current.openAlert('조회된 결과가 없습니다.');
                    }
                },
            }),
        );
        PathUtil.pushState(location.pathname, params);
    };

    useEffect(() => {
        dispatch(
            handleControl({
                columns,
                onChangePageInfo,
                onRowDoubleClick,
                params,
            }),
        );
    }, [params]);

    const onRowDoubleClick = (row, params) => {
        modalRef.current.open(<SmsHistoryModal modalRef={modalRef} row={row} />, 'medium');
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                bgnDt,
                endDt,
                sendTypeCd,
                resCode,
                phone,
                callback,
                page: defaultGridData.page,
                pageSize: gridData.pageSize,
            });
        }
    };

    const handleReSend = useCallback((row) => {
        console.log(row);
        dispatch(
            actionSmsSend({
                data: {
                    sendTypeCd: row.sendTypeCd,
                    callback: row.callback,
                    title: row.title,
                    msg: row.msg,
                    phoneList: [row.phone],
                },
                callback: (result) => {
                    let msg = '';
                    if (result.success > 0) {
                        msg = '문자 재발송에 성공 했습니다.';
                    } else {
                        msg = '문자 재발송에 실패 했습니다.';
                    }
                    popupRef.current.openAlert(msg, () => {
                        return function () {
                            onClickSearch({
                                ...params,
                            });
                        };
                    });
                },
            }),
        );
    });

    const columns = useMemo(
        () => [
            {
                field: 'sendDttm',
                headerName: '발송일시',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 10,
            },
            {
                field: 'sendTypeCd',
                headerName: '발송유형',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 3,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SMS_SEND_TYPE, params.row.sendTypeCd),
            },
            {
                field: 'phone',
                headerName: '수신번호',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
                renderCell: (params) => FormatUtil.telNoFormatter(params.row.phone),
            },
            {
                field: 'callback',
                headerName: '발신번호',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
                renderCell: (params) => FormatUtil.telNoFormatter(params.row.callback),
            },
            {
                field: 'msg',
                headerName: '내용',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            {
                field: 'resMessage',
                headerName: '발송결과',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 5,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 5,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={(e) => onRowDoubleClick(item.row)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'재발송'}>
                            <IconButton onClick={(e) => handleReSend(item.row)}>
                                <SendIcon />
                            </IconButton>
                        </Tooltip>
                    </>
                ),
            },
        ],
        [params],
    );

    return (
        <>
            <div className='con-form-wrap '>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='search-condition-box'>
                                <div className='form-box-container'>
                                    <DatePickerBox
                                        title='시작일자'
                                        value={date2ViewDate(bgnDt)}
                                        size='medium'
                                        onChange={(e) => setBgnDt(viewDate2SaveDate(e.target.value))}
                                    />
                                    <DatePickerBox
                                        title='종료일자'
                                        value={date2ViewDate(endDt)}
                                        size='medium'
                                        onChange={(e) => setEndDt(viewDate2SaveDate(e.target.value))}
                                    />
                                    <SelectionBox
                                        title='문자메시지발송유형'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.SMS_SEND_TYPE)}
                                        value={sendTypeCd}
                                        onChange={(e) => setSendTypeCd(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <SelectionBox
                                        title='문자메시지발송결과'
                                        w140
                                        options={CodeUtil.getCodes(CODE_GROUP_ID.SMS_SEND_RESULT)}
                                        value={resCode}
                                        onChange={(e) => setResCode(e.target.value)}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <TelNoInputBox
                                        title='수신번호'
                                        value={phone}
                                        size='medium'
                                        setTelNo={setPhone}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                    <TelNoInputBox
                                        title='발신번호'
                                        value={callback}
                                        size='medium'
                                        setTelNo={setCallback}
                                        onKeyDown={(e) => onKeyDown(e)}
                                    />
                                </div>
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            bgnDt,
                                            endDt,
                                            sendTypeCd,
                                            resCode,
                                            phone,
                                            callback,
                                            page: defaultGridData.page,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const SmsHistoryView = () => {
    const modalRef = useRef(null);
    const popupRef = useRef(null);
    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg05'>
                    <h2 className='con-title'>{VIEW_SMS_HISTORY.title}</h2>
                    <p className='con-title-p'>{VIEW_SMS_HISTORY.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <SmsHistoryArea modalRef={modalRef} popupRef={popupRef} />
                <div className='con-tb-wrap'>
                    <div className='con-tb-title'>
                        <h3 className='tb-tit-name'>SMS발송이력</h3>
                    </div>
                </div>
                <TableBox defaultWide={false} />
            </div>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </section>
    );
};

export default SmsHistoryView;
